<template>
  <div class="feed-action-button">
    <template v-if="!single">
      -
      <a
        @click.prevent="openUpdateModal"
        v-b-tooltip.hover
        :title="`Update with MetaMask with MetaMask transaction`"
      >
        <i class="fa fa-cloud-upload"></i>
        Send update tx
      </a>
    </template>
    <template v-else>
      <a
        @click.prevent="openUpdateModal"
        v-b-tooltip.hover
        :title="`Update feed with MetaMask transaction`"
      >
        <i class="fa fa-cloud-upload"></i>
        Push on-chain update
      </a>
    </template>

    <UpdateFeedModal
      v-model="isUpdateModalVisible"
      :feed-data="item"
      @update-success="handleUpdateSuccess"
      @update-error="handleUpdateError"
    />
  </div>
</template>

<script>
  import UpdateFeedModal from "./UpdateFeedModal.vue";

  export default {
    name: "FeedActionButton",
    components: {
      UpdateFeedModal,
    },
    props: {
      single: {
        type: Boolean,
        default: false,
      },
      item: {
        type: Object,
        required: true,
      },
    },
    data() {
      return {
        isUpdateModalVisible: false,
      };
    },
    methods: {
      openUpdateModal() {
        this.isUpdateModalVisible = true;
      },
      handleUpdateSuccess(data) {
        this.$bvToast.toast(`Feed ${data.feedId} updated successfully`, {
          title: "Update Successful",
          variant: "success",
          solid: true,
          autoHideDelay: 5000,
        });

        this.$emit("feed-updated", {
          feedId: data.feedId,
          transactionHash: data.transactionHash,
        });
      },
      handleUpdateError(data) {
        this.$bvToast.toast(`Failed to update feed: ${data.error.message}`, {
          title: "Update Failed",
          variant: "danger",
          solid: true,
          autoHideDelay: 5000,
        });
      },
    },
  };
</script>

<style scoped>
  .feed-action-button {
    display: inline-block;
  }
</style>
